import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useSeo } from "../hooks/useSeo";

export default function ThankYou() {
  useSeo({ title: "You're in! — Practical AI for Everyday Life", description: "Thanks for subscribing." });
  return (
    <section className="bg-plexus min-h-[calc(100vh-68px)]" data-testid="thankyou-page">
      <div className="container-brand flex min-h-[calc(100vh-68px)] flex-col items-center justify-center py-20 text-center">
        <span className="grid h-16 w-16 place-items-center rounded-full bg-teal text-bone"><CheckCircle2 size={34} /></span>
        <h1 className="mt-6 text-4xl text-bone sm:text-5xl">You're in! 🎉</h1>
        <p className="mt-4 max-w-lg text-lg text-on-navy-body">
          Thanks for joining. Keep an eye on your inbox — the next free setup is on its way. In the meantime,
          go grab one now.
        </p>
        <div className="on-navy mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/setups" className="btn btn-primary" data-testid="thankyou-browse">Browse the setups</Link>
          <Link to="/my-ai" className="btn btn-secondary" data-testid="thankyou-start">Meet Mochi, my AI</Link>
        </div>
      </div>
    </section>
  );
}
